import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryBrandNewss(
  {
    title, brandId, page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/brand-news`,
    method: 'get',
    params: {
      title,
      brandId,
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryBrandNews(brandNewsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/brand-news/${brandNewsId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  title
 * @param  subTitle
 * @param  postAt
 * @param  brandId
 * @param  coverPath
 * @param  topImagePath
 * @param  content
 * @param  contentImages
 * @param  tags
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addBrandNews(
  {
    title,
    subTitle,
    postAt,
    brandId,
    coverPath,
    topImagePath,
    content,
    contentImages,
    tags,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/brand-news`,
    method: 'post',
    data: {
      title,
      subTitle,
      postAt,
      brandId,
      coverPath,
      topImagePath,
      content,
      contentImages,
      tags,
    },
  });
}

/**
 * 更新
 * @param brandNewsId
 * @param  title
 * @param  subTitle
 * @param  postAt
 * @param  brandId
 * @param  coverPath
 * @param  topImagePath
 * @param  content
 * @param  contentImages
 * @param  tags
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateBrandNews(brandNewsId, {
  title,
  subTitle,
  postAt,
  brandId,
  coverPath,
  topImagePath,
  content,
  contentImages,
  tags,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/brand-news/${brandNewsId}`,
    method: 'patch',
    data: {
      title,
      subTitle,
      postAt,
      brandId,
      coverPath,
      topImagePath,
      content,
      contentImages,
      tags,
    },
  });
}

/**
 * 删除
 * @param brandNewsId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteBrandNews(brandNewsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/brand-news/${brandNewsId}`,
    method: 'delete',
  });
}

export default {};
